module.exports = __webpack_public_path__ + "img/doctor.25eec5e6.jpg";